import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'normalize',
    standalone: false
})
export class NormalizePipe implements PipeTransform {
    transform(text: string): any {
        return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
}
